import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

function FaqContent(props) {
  let history = useHistory();

  console.log(history);
  return (
    <section className="MainContent faq">
      <h1 className="PageTitle">FAQ</h1>
      <p>
        <a
          href="/"
          className="go-back"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
          }}
        >
          &larr; Return Home
        </a>
      </p>
      <p>
        A word of warning: We are conducting this experience during a trialing
        period. There are delays in deliveries. There are many complications
        we’re facing in this pandemic, and while we greatly value this
        experience, there are greater and more important things in the world.
        Because of this, there can be delays and complications. If your box
        doesn’t arrive to you in time, worry not, we will get you scheduled in
        for a later show. If a show is postponed due to the safety and or health
        of our team, we will get you scheduled for a later show. Thanks for
        being the greatest community out there and for your on-going support.
        Let’s have some fun.
      </p>
      <h2 className="h3">What is One Day Die?</h2>
      <p>One Day Die is an interactive, guided séance experience.</p>
      <h2 className="h3">
        I have been to other Zoom shows for a fraction of the price… What
        gives?!
      </h2>
      <p>
        We know that we’re a bit more expensive than a lot of other shows, but
        as we have done in the past, we’re trying to innovate and push the
        envelope as far as we possibly can. There are multiple actors, sets, and
        a skilled crew behind all of this. We’re not sacrificing production
        value and want to bring the highest caliber of quality to you, the
        audience, because we love you.
      </p>
      <p>
        We don’t want you to feel like a small window in a sea of other windows
        with little faces in them. So we’re putting a piece of the show – the
        box – right in your hands.
      </p>
      <p>
        These boxes are all being handmade by us in Los Angeles, and we’re doing
        it safely. You can’t imagine how much hand sanitizer will be used in the
        process of making your box. They are heavily curated and intricately
        designed. It’s our hope that after this experience, you will cherish the
        box in its entirety or at least several of the items inside it. We can’t
        wait for you to pass this weird ass box down to your kids, then their
        kids, etc. Your next family heirloom?!
      </p>
      <h2 className="h3">How long is the experience?</h2>
      <p>
        This is a contained experience that will run roughly an hour and a half.
        For the more curious bunnies, there are a few fun rabbit holes that will
        allow you to borough a little deeper – we’ve already done a few fun
        things which many of you have taken part in. But, since we’re all
        friends here and honesty is important, this is not a long running ARG
        that we’re known for, such as The Tension Experience, Lust, or
        iConfidant, etc.
      </p>
      <p>
        For this project, we want to bring something different to you but with
        the same quality and intensity we have in our past experiences. For this
        reason, this experience has been designed to be more accessible. We love
        our community and see this an opportunity to show more people how
        awesome and engaging this world can be. We hope you’ll support us, and
        DO NOT WORRY, there will be plenty of time in the future where we will
        drive you crazy for months and months.
      </p>
      <h2 className="h3">Will I need to sign a waiver?</h2>
      <p>
        Absolutely. Just because this show is a little more contained than our
        typical experiences, doesn’t mean we’re holding back at all. Because of
        the things we’re exposing you to and because you’re getting a physical
        box of crazy things sent to you, there will be a waiver for you to sign.
        We will provide clear instructions on how to use your box, and if you go
        rogue and something bad happens – that’s on you. If you summon a demon
        and can’t get it back in your box – don’t call us. You signed a waiver
        and that is your demon now. Good luck.
      </p>
      <p>
        If you’re not comfortable signing a waiver before buying a ticket, then
        unfortunately, we’re not sure this experience is for you, and we hope to
        see you down the road.
      </p>
      <h2 className="h3">Does my ticket allow others to join me?</h2>
      <p>
        Look, we’re going to say yes, but if we find out you guys are breaking
        quarantine protocols and not maintaining a COVID-friendly lifestyle…
        We’ll find you and you’re not going to like it.
      </p>
      <p>
        One ticket will get you one box, and if you have roommates or family
        that want to join in on the fun, the box can support a few people. We’d
        love for everyone to have their own box, but we understand that it’s a
        bit easier if all the roommates are splitting the cost of the box, so
        we’re happy to support safe sharing of the box.
      </p>
      <p>
        With that, we do want to be clear that the boxes are built with only 1
        of each item. So if you have a group, there will be some sharing, and if
        you have too many people trying to share the box, it can become a time
        burden, and the show will go on. We can’t wait.
      </p>
      <p>
        And if we weren’t clear (clears throat) – we are forbidding any mingling
        of people for this experience that are not in your household. We’re
        fighting a pandemic, people, and we want to be on the right side of
        this. So thanks for staying safe.
      </p>
      <h2 className="h3">Will this experience be interactive?</h2>
      <p>
        Our greatest goal in this is for it to feel different than most
        Zoom-style shows out there. We don’t want you to feel like you’re just
        watching. Every day between now and your show, we are pushing ourselves
        to innovate and find ways to be more and more interactive. Obviously,
        we’re working with limitations since this is a remote show, so keep that
        in mind, but we hope you leave this feeling like you were really part of
        the narrative.
      </p>
      <p>
        This is where we plug the golden rule of these experiences: you get out
        what you put in. If you’re going to sit quietly during the séance and
        just silently scream with fear on the inside, it’s going to feel less
        interactive. It is a group experience, so be a part of the group. There
        will be times to be quiet. There will be times to mingle. There will be
        times to interact. So get out there!
      </p>
      <h2 className="h3">
        I live out of the country… Will I be able to participate?
      </h2>
      <p>
        We wish we had a better answer for this… We hope so. Our goal is to make
        that happen, but right now, it’s really hard to get reliable
        international shipping. There’s also a lot of issues with Customs
        opening packages before allowing them to be shipped, and that’s how an
        entity escapes and takes over London or something. We will keep you
        posted on this.
      </p>
      <h2 className="h3">Is this show scary? Is it appropriate for kids?</h2>
      <p>
        This show might not be appropriate for adults. There is a 100% chance
        that some of you will refuse to do some of the things the séance will
        demand. This is an 18 and up experience, so it’s best to keep your kids
        and pets away from this experience. Unless you don’t like your pet, then
        we might need them and you’d be doing us a real favor.
      </p>
      <p>
        If you let yourself fall under the spell of this experience, if you
        approach with an open mind and allow yourself to take part in the
        narrative, this will absolutely be a scary experience. We are dealing
        with heavy adult themes, graphic imagery, occult subject matter,
        violence, ritualistic magic, branching narratives, death, paranormal
        events, complex technology, a lil’ Satan stuff, blood, animal sacrifice,
        fire, and whatever weird juju you bring to this thing.
      </p>
      <p>So… Come at your own risk. Keep the kids away.</p>
      <h2 className="h3">Are the tickets refundable or transferable?</h2>
      <p>
        Because of the current pandemic, we are running this with a very lean
        team, and this is a very complicated process… Because of this, we can’t
        offer any refunds on the tickets. Nor can we allow you to transfer your
        ticket or give your box to another person. The purchase is final.
      </p>
      <p>
        As much as we want you to buy a ticket, please make sure it’s something
        you are ready to commit to. Because there is no going back once the
        purchase has been made. Thanks for understanding!
      </p>
      <p>
        <Link to="/">&larr; Return Home</Link>
      </p>
    </section>
  );
}

export default FaqContent;
